// import { saveAs } from 'file-saver';
import { useEffect, useState } from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
// import * as XLSX from 'xlsx';
import { IoMdSearch } from "react-icons/io";
import { LIVE_URL } from "../../../config/config";
import useAuthToken from "../../../hooks/useAuthToken";
import styles from "./css/ListLanguage.module.scss";
import ProductTable from "./datatable/ProductTable";

const ListLanguage = () => {
  const { token } = useAuthToken();
  const navigate = useNavigate();
  const location = useLocation();

  // define state
  const [title, setTitle] = useState(
    new URLSearchParams(location.search).get("title") || ""
  );
  const [languages, setLanguages] = useState([]);
  const [filteredLanguages, setFilteredLanguages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [limit, setLimit] = useState(10);
  const [sortField, setSortField] = useState("id");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLanguage = async () => {
      try {
        setLoading(true);
        const queryParams = new URLSearchParams();
        if (title) {
          queryParams.set("title", title);
        } else {
          queryParams.set("page", currentPage);
          queryParams.set("pageSize", entriesPerPage);
          queryParams.set("sort_by", sortField);
          queryParams.set("order_by", sortOrder);
          queryParams.set("limit", limit);
        }

        const response = await fetch(
          `${LIVE_URL}/admin/language/list?${queryParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();

        if (response.ok && data?.data?.language) {
          setLanguages(data.data.language);
          setFilteredLanguages(data.data.language);
          setTotalPages(
            Math.ceil(data.data.pagination.totalCount / entriesPerPage)
          );
        } else {
          setLanguages([]);
          setFilteredLanguages([]);
          setTotalPages(1);
        }
      } catch (error) {
        setLanguages([]);
        setFilteredLanguages([]);
        setTotalPages(1);
      } finally {
        setLoading(false);
      }
    };
    if (!loading) {
      fetchLanguage();
    }
  }, [token, currentPage, title, entriesPerPage, sortField, sortOrder]);

  useEffect(() => {
    if (languages) {
      const filtered = languages.filter((language) =>
        language.title.toLowerCase().includes(title.toLowerCase())
      );
      setFilteredLanguages(filtered);
    } else {
      setFilteredLanguages(languages);
    }
  }, [title, languages]);

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      const message = params.get("message");
      if (message) {
        setPopupMessage(decodeURIComponent(message));
        setTimeout(() => {
          setPopupMessage("");
          navigate({ search: "" });
        }, 2000);
      }
    }
  }, [location.search, navigate]);

  const handleLimitChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setLimit(newLimit);
    setEntriesPerPage(newLimit);
    setCurrentPage(1);
    setTotalPages(Math.ceil(filteredLanguages.length / newLimit));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Added function to go two pages back
  const handlePreviousTwo = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  // Added function to go two pages forward
  const handleNextTwo = () => {
    if (currentPage !== totalPages) {
      setCurrentPage(totalPages);
    }
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (currentPage > 1) {
      pageNumbers.push(currentPage - 1);
    }
    pageNumbers.push(currentPage);
    if (currentPage < totalPages) {
      pageNumbers.push(currentPage + 1);
    }
    return pageNumbers;
  };

  const updateUrl = (search) => {
    const params = new URLSearchParams(location.search);
    if (search) {
      params.set("title", search);
    } else {
      params.delete("title");
    }
    navigate({ search: params.toString() });
  };

  useEffect(() => {
    updateUrl(title);
  }, [title]);

  // const exportToExcel = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(filteredLanguages);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Languages");
  //   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(data, "languages.xlsx");
  // };

  return (
    <>
      <div className={`${styles.list_language}`}>
        {popupMessage && (
          <div className={`${styles.update_message}`}>
            <p>{popupMessage}</p>
          </div>
        )}
        <header>
          <h2>Language List Management</h2>
        </header>
        {/* entry section */}
        <section className={`${styles.section}`}>
          <div className={`${styles.user_entry}`}>
            <div className={`${styles.entries}`}>
              <label htmlFor="limit">Show</label>
              <select value={limit} onChange={handleLimitChange}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <label htmlFor="entries">entries</label>
            </div>
            {/* <div className={`${styles.search_section}`}> */}
            <div className={`${styles.search}`}>
              {/* <label htmlFor="search">Search: </label> */}
              <IoMdSearch />
              <input
                type="search"
                id="search"
                value={title}
                placeholder="Search by title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            {/* <div className={`${styles.export_button}`}>
                <button onClick={exportToExcel}>Export</button>
              </div>
            </div> */}
          </div>

          {/* user information section */}
          <div className={`${styles.user_info}`}>
            <ProductTable
              languages={filteredLanguages}
              setLanguages={setLanguages}
              rows={entriesPerPage}
              title={title}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              sortField={sortField}
              sortOrder={sortOrder}
              setSortField={setSortField}
              setSortOrder={setSortOrder}
              loading={loading}
              setLoading={setLoading}
            />
          </div>

          {/* pagination section */}
          <div className={`${styles.pagination}`}>
            <button onClick={handlePreviousTwo} disabled={currentPage === 1}>
              <FiChevronsLeft />
            </button>
            <button onClick={handlePrevious} disabled={currentPage === 1}>
              <FiChevronLeft />
            </button>
            {getPageNumbers().map((page) => (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={currentPage === page ? styles.active : ""}
                disabled={page > totalPages}
              >
                {page}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              <FiChevronRight />
            </button>
            <button
              onClick={handleNextTwo}
              disabled={
                currentPage === totalPages || currentPage === totalPages - 1
              }
            >
              <FiChevronsRight />
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default ListLanguage;
